import { Controller } from '@hotwired/stimulus';
import Swiper from 'swiper/bundle'

export default class extends Controller {
  connect() {
    var itemSlider = new Swiper(".item-slider", {
      loop: true,
      slidesPerView: 1.9,
      slidesPerGroup: 1,
      spaceBetween: 12,
      navigation: {
        nextEl: ".item-slider__button-next",
        prevEl: ".item-slider__button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2
        },
        1280: {
          loopAddBlankSlides: false,
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 20,
        },
      },
    });
  }
}